/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { PriceCalculatorTester } from '../PriceCalculatorTester'

export class PriceCalculatorTester__factory extends ContractFactory {
  constructor(
    linkLibraryAddresses: PriceCalculatorTesterLibraryAddresses,
    signer?: Signer
  ) {
    super(
      _abi,
      PriceCalculatorTester__factory.linkBytecode(linkLibraryAddresses),
      signer
    )
  }

  static linkBytecode(
    linkLibraryAddresses: PriceCalculatorTesterLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$1b126b2bb976a2adec3373a199e7772d12\\$__', 'g'),
      linkLibraryAddresses['__$1b126b2bb976a2adec3373a199e7772d12$__']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(overrides?: Overrides): Promise<PriceCalculatorTester> {
    return super.deploy(overrides || {}) as Promise<PriceCalculatorTester>
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): PriceCalculatorTester {
    return super.attach(address) as PriceCalculatorTester
  }
  connect(signer: Signer): PriceCalculatorTester__factory {
    return super.connect(signer) as PriceCalculatorTester__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceCalculatorTester {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PriceCalculatorTester
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_strike',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '_maturity',
        type: 'int256'
      },
      {
        internalType: 'uint256',
        name: '_iv',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isPut',
        type: 'bool'
      }
    ],
    name: 'calculateDelta',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_strike',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maturity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_iv',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isPut',
        type: 'bool'
      }
    ],
    name: 'calculatePrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_strike',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_maturity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_x0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_x1',
        type: 'uint256'
      },
      {
        internalType: 'bool',
        name: '_isPut',
        type: 'bool'
      }
    ],
    name: 'calculatePrice2',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_maturity',
        type: 'uint256'
      }
    ],
    name: 'getSqrtMaturity',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  }
]

const _bytecode =
  '0x608060405234801561001057600080fd5b506103dd806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c80633a96a669146100515780635276e0cd14610076578063c2bcddc114610089578063cf8d0b821461009c575b600080fd5b61006461005f366004610380565b6100af565b60405190815260200160405180910390f35b610064610084366004610338565b610164565b610064610097366004610320565b610212565b6100646100aa366004610338565b6102a0565b604051633a96a66960e01b8152600481018790526024810186905260448101859052606481018490526084810183905281151560a482015260009073__$1b126b2bb976a2adec3373a199e7772d12$__90633a96a6699060c40160206040518083038186803b15801561012157600080fd5b505af4158015610135573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101599190610308565b979650505050505050565b604051635276e0cd60e01b815260048101869052602481018590526044810184905260648101839052811515608482015260009073__$1b126b2bb976a2adec3373a199e7772d12$__90635276e0cd9060a4015b60206040518083038186803b1580156101d057600080fd5b505af41580156101e4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102089190610308565b9695505050505050565b60405163c2bcddc160e01b81526004810182905260009073__$1b126b2bb976a2adec3373a199e7772d12$__9063c2bcddc19060240160206040518083038186803b15801561026057600080fd5b505af4158015610274573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102989190610308565b90505b919050565b6040516367c685c160e11b815260048101869052602481018590526044810184905260648101839052811515608482015260009073__$1b126b2bb976a2adec3373a199e7772d12$__9063cf8d0b829060a4016101b8565b8035801515811461029b57600080fd5b600060208284031215610319578081fd5b5051919050565b600060208284031215610331578081fd5b5035919050565b600080600080600060a0868803121561034f578081fd5b85359450602086013593506040860135925060608601359150610374608087016102f8565b90509295509295909350565b60008060008060008060c08789031215610398578081fd5b86359550602087013594506040870135935060608701359250608087013591506103c460a088016102f8565b9050929550929550929556fea164736f6c6343000802000a'

export interface PriceCalculatorTesterLibraryAddresses {
  ['__$1b126b2bb976a2adec3373a199e7772d12$__']: string
}
